import type { components } from '@social-studio/api-client';

/** Time between two polls of a running turn (spec 110 section 4.15.2: the panel polls, there is no streaming). */
export const TURN_POLL_MS = 1500;
/** Polls after which the panel stops waiting: about ten minutes, the server's own turn timeout. */
export const TURN_MAX_POLLS = 400;

type TurnStatus = components['schemas']['AssistantTurnDto']['status'];

/** Whether a turn will not change any more. */
export const isTerminal = (status: TurnStatus): boolean => status === 'succeeded' || status === 'failed' || status === 'rejected_budget';

/** TanStack `refetchInterval` for a turn poll: stops once terminal and at the cap, never polls without an end. */
export function turnPollInterval(
  status: TurnStatus | undefined,
  polls: number,
  limits: { readonly intervalMs: number; readonly maxPolls: number } = { intervalMs: TURN_POLL_MS, maxPolls: TURN_MAX_POLLS },
): number | false {
  if (status !== undefined && isTerminal(status)) return false;
  return polls >= limits.maxPolls ? false : limits.intervalMs;
}
